module.exports = __webpack_public_path__ + "img/logo_horizontal.e6c2a582.png";